import { ContextMenu } from "lib/@components/context-menu-bar"

export const RegimeContextMenu = ContextMenu("regime")
